export default "__VITE_ASSET__Cojm4xgh__"